<template>
    <div class="col-12 py-2">
        <div class="w-100 mt-2">
            <h6 class="mb-2 d-flex align-items-center">
                <b class="me-2"> {{ type }} Medicare</b>
            </h6>
        </div>
    </div>
    <template v-if="type == 'Primary'">
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label for="effective-date-a"> Medicare Part A Effective Date </label>
            <DatePicker :getDate="onDateChange">
                <div class="input-group date datepickerInput">
                    <input
                        name="effective-date-a"
                        type="text"
                        class="form-control"
                        placeholder="Enter Date"
                        autocomplete="off"
                        :value="referral.Insurance.PrimaryMedicarePartADate"
                        @change="handleDateChange"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label for="effective-date-b"> Medicare Part B Effective Date </label>
            <DatePicker :getDate="onDateChange">
                <div class="input-group date datepickerInput">
                    <input
                        name="effective-date-b"
                        type="text"
                        class="form-control"
                        placeholder="Enter Date"
                        autocomplete="off"
                        :value="referral.Insurance.PrimaryMedicarePartBDate"
                        @change="handleDateChange"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label for="referral-exisiting-prior"> Existing Prior Episodes </label>
            <select
                class="form-select"
                name="referral-exisiting-prior"
                v-model="referral.Insurance.PrimaryExistingPriorEpisode"
            >
                <option :value="null">Select Option</option>
                <option v-for="status in options" :key="status.label" :value="status.value">
                    {{ status.label }}
                </option>
            </select>
        </div>
    </template>
    <template v-if="type == 'Secondary'">
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label for="effective-date-a"> Medicare Part A Effective Date </label>
            <DatePicker :getDate="onDateChange">
                <div class="input-group date datepickerInput">
                    <input
                        name="effective-date-a"
                        type="text"
                        class="form-control"
                        placeholder="Enter Date"
                        autocomplete="off"
                        :value="referral.Insurance.SecondaryMedicarePartADate"
                        @change="handleDateChange"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label for="effective-date-b"> Medicare Part B Effective Date </label>
            <DatePicker :getDate="onDateChange">
                <div class="input-group date datepickerInput">
                    <input
                        name="effective-date-b"
                        type="text"
                        class="form-control"
                        placeholder="Enter Date"
                        autocomplete="off"
                        :value="referral.Insurance.SecondaryMedicarePartBDate"
                        @change="handleDateChange"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label for="referral-exisiting-prior"> Existing Prior Episodes </label>
            <select
                class="form-select"
                name="referral-exisiting-prior"
                v-model="referral.Insurance.SecondaryExistingPriorEpisode"
            >
                <option :value="null">Select Option</option>
                <option v-for="status in options" :key="status.label" :value="status.value">
                    {{ status.label }}
                </option>
            </select>
        </div>
    </template>
    <template v-if="type == 'Tertiary'">
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label for="effective-date-a"> Medicare Part A Effective Date </label>
            <DatePicker :getDate="onDateChange">
                <div class="input-group date datepickerInput">
                    <input
                        name="effective-date-a"
                        type="text"
                        class="form-control"
                        placeholder="Enter Date"
                        autocomplete="off"
                        :value="referral.Insurance.TertiaryMedicarePartADate"
                        @change="handleDateChange"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label for="effective-date-b"> Medicare Part B Effective Date </label>
            <DatePicker :getDate="onDateChange">
                <div class="input-group date datepickerInput">
                    <input
                        name="effective-date-b"
                        type="text"
                        class="form-control"
                        placeholder="Enter Date"
                        autocomplete="off"
                        :value="referral.Insurance.TertiaryMedicarePartBDate"
                        @change="handleDateChange"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </div>
        <div class="form-group col-12 col-lg-12 pe-lg-12">
            <label for="referral-exisiting-prior"> Existing Prior Episodes </label>
            <select
                class="form-select"
                name="referral-exisiting-prior"
                v-model="referral.Insurance.TertiaryExistingPriorEpisode"
            >
                <option :value="null">Select Option</option>
                <option v-for="status in options" :key="status.label" :value="status.value">
                    {{ status.label }}
                </option>
            </select>
        </div>
    </template>
</template>
<script lang="ts" src="./Medicare.ts"></script>
